export function calculateProductMultiplier(costPriceWithIVA: unknown, salePrice: unknown): number {
  const costWithIVA = Number(costPriceWithIVA);
  const sale = Number(salePrice);

  if (!Number.isFinite(costWithIVA) || !Number.isFinite(sale) || costWithIVA <= 0 || sale < 0) {
    return 0;
  }

  return Number((sale / costWithIVA).toFixed(2));
}
